export default function About() {
  return (
    <>
      <section id="about" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8">
                Meet Matthew Beltrame
              </h2>
              <div className="space-y-6">
                <p className="text-lg text-gray-700 leading-relaxed">
                  With over 20 years of hands-on experience in the construction industry, Matthew Beltrame brings 
                  unparalleled expertise to every construction layout design and formwork project across British Columbia.
                </p>
                <p className="text-lg text-gray-700 leading-relaxed">
                  Matthew holds a Bachelor of Applied Sciences in Civil Engineering, 
                  combining academic excellence with extensive practical field experience. This unique blend of theoretical knowledge 
                  and real-world application ensures that every project is executed with precision and efficiency.
                </p>
                <p className="text-lg text-gray-700 leading-relaxed">
                  Specializing in construction formwork, layout design, and formwork drawing services, Matthew has successfully 
                  completed hundreds of projects throughout Vancouver, Burnaby, Surrey, and Victoria, earning a reputation 
                  for delivering exceptional results on time and within budget.
                </p>
              </div>

              <div className="mt-8 grid grid-cols-2 gap-8">
                <div className="text-center">
                  <div className="text-4xl font-bold text-teal-600 mb-2">20+</div>
                  <div className="text-gray-600">Years Experience</div>
                </div>
                <div className="text-center">
                  <div className="text-4xl font-bold text-teal-600 mb-2">50+</div>
                  <div className="text-gray-600">Projects Completed</div>
                </div>
              </div>

              <div className="mt-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Professional Qualifications</h3>
                <div className="space-y-3">
                  <div className="flex items-center">
                    <i className="ri-graduation-cap-line text-teal-600 mr-3"></i>
                    <span className="text-gray-700">Bachelor of Applied Sciences in Civil Engineering</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-award-line text-teal-600 mr-3"></i>
                    <span className="text-gray-700">Certified Construction Manager</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-file-shield-line text-teal-600 mr-3"></i>
                    <span className="text-gray-700">WSBC Safety Certified</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-shield-check-line text-teal-600 mr-3"></i>
                    <span className="text-gray-700">Fully Licensed and Insured</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="relative">
              <div className="w-full h-96 bg-gradient-to-br from-teal-100 to-teal-200 rounded-xl shadow-2xl flex items-center justify-center">
                <div className="text-center">
                  <i className="ri-building-2-line text-6xl text-teal-600 mb-4"></i>
                  <h3 className="text-2xl font-bold text-teal-800">Professional Excellence</h3>
                  <p className="text-teal-700 mt-2">20+ Years of Construction Expertise</p>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-20">
            <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center">Areas of Expertise</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              <div className="bg-gray-50 rounded-lg p-6 text-center">
                <i className="ri-building-2-line text-3xl text-teal-600 mb-4"></i>
                <h4 className="font-semibold text-gray-900 mb-2">Residential Construction</h4>
                <p className="text-sm text-gray-600">Custom homes, townhouses, and multi-family developments</p>
              </div>
              <div className="bg-gray-50 rounded-lg p-6 text-center">
                <i className="ri-building-line text-3xl text-teal-600 mb-4"></i>
                <h4 className="font-semibold text-gray-900 mb-2">Commercial Projects</h4>
                <p className="text-sm text-gray-600">Office buildings, retail spaces, and mixed-use developments</p>
              </div>
              <div className="bg-gray-50 rounded-lg p-6 text-center">
                <i className="ri-road-map-line text-3xl text-teal-600 mb-4"></i>
                <h4 className="font-semibold text-gray-900 mb-2">Infrastructure</h4>
                <p className="text-sm text-gray-600">Bridges, retaining walls, and municipal projects</p>
              </div>
              <div className="bg-gray-50 rounded-lg p-6 text-center">
                <i className="ri-tools-line text-3xl text-teal-600 mb-4"></i>
                <h4 className="font-semibold text-gray-900 mb-2">Specialized Formwork</h4>
                <p className="text-sm text-gray-600">Complex concrete structures and architectural features</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Scale Without the Overhead Section */}
      <section className="py-20 bg-gradient-to-br from-slate-50 to-slate-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Bid Bigger. Build Better. Scale Faster.
            </h2>
            <p className="text-xl text-gray-700 max-w-4xl mx-auto leading-relaxed">
              Partner with Dinari: Expand Your Scope
            </p>
          </div>

          <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12 mb-12">
            <div className="prose prose-lg max-w-none">
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                For newer construction firms and growing contractors, the jump from simple residential builds to complex, 
                high-stakes commercial contracts is a technical one.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                <strong className="text-teal-600">Dinari Designs acts as your instant Senior Engineering Department.</strong> By partnering with us, 
                you can expand your scope of business to include high-rise towers, complex hillside developments, and architectural 
                concrete—without the $100k+ cost of hiring a high-level in-house team.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                We handle the complex AutoCAD detailing and technical layout coordination, allowing you to focus on site execution 
                and business growth. <strong>Don't just compete—dominate your niche.</strong>
              </p>
            </div>
          </div>

          {/* Capability Map */}
          <div className="mb-12">
            <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center">
              What You Unlock by Partnering with Dinari Designs
            </h3>
            <div className="overflow-x-auto">
              <table className="w-full bg-white rounded-xl shadow-lg overflow-hidden">
                <thead>
                  <tr className="bg-teal-600 text-white">
                    <th className="px-6 py-4 text-left font-semibold">What You Do (Site Ops)</th>
                    <th className="px-6 py-4 text-left font-semibold">What We Do (Technical Support)</th>
                    <th className="px-6 py-4 text-left font-semibold">Result (Growth)</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  <tr className="hover:bg-teal-50 transition-colors duration-200">
                    <td className="px-6 py-4">
                      <div className="flex items-center">
                        <i className="ri-team-line text-2xl text-teal-600 mr-3"></i>
                        <span className="text-gray-800 font-medium">On-site Crew Management</span>
                      </div>
                    </td>
                    <td className="px-6 py-4">
                      <div className="flex items-center">
                        <i className="ri-pencil-ruler-2-line text-2xl text-teal-600 mr-3"></i>
                        <span className="text-gray-800">Professional AutoCAD Detailing</span>
                      </div>
                    </td>
                    <td className="px-6 py-4">
                      <div className="flex items-center">
                        <i className="ri-building-4-line text-2xl text-teal-600 mr-3"></i>
                        <span className="text-gray-800 font-semibold">Bid on High-Rise Projects</span>
                      </div>
                    </td>
                  </tr>
                  <tr className="hover:bg-teal-50 transition-colors duration-200">
                    <td className="px-6 py-4">
                      <div className="flex items-center">
                        <i className="ri-shopping-cart-line text-2xl text-teal-600 mr-3"></i>
                        <span className="text-gray-800 font-medium">Material Purchasing</span>
                      </div>
                    </td>
                    <td className="px-6 py-4">
                      <div className="flex items-center">
                        <i className="ri-file-list-3-line text-2xl text-teal-600 mr-3"></i>
                        <span className="text-gray-800">Accurate Technical Markups</span>
                      </div>
                    </td>
                    <td className="px-6 py-4">
                      <div className="flex items-center">
                        <i className="ri-percent-line text-2xl text-teal-600 mr-3"></i>
                        <span className="text-gray-800 font-semibold">Reduce Waste & Errors</span>
                      </div>
                    </td>
                  </tr>
                  <tr className="hover:bg-teal-50 transition-colors duration-200">
                    <td className="px-6 py-4">
                      <div className="flex items-center">
                        <i className="ri-customer-service-2-line text-2xl text-teal-600 mr-3"></i>
                        <span className="text-gray-800 font-medium">Client Relations</span>
                      </div>
                    </td>
                    <td className="px-6 py-4">
                      <div className="flex items-center">
                        <i className="ri-map-pin-line text-2xl text-teal-600 mr-3"></i>
                        <span className="text-gray-800">Complex Site Planning</span>
                      </div>
                    </td>
                    <td className="px-6 py-4">
                      <div className="flex items-center">
                        <i className="ri-landscape-line text-2xl text-teal-600 mr-3"></i>
                        <span className="text-gray-800 font-semibold">Take on Hillside Developments</span>
                      </div>
                    </td>
                  </tr>
                  <tr className="hover:bg-teal-50 transition-colors duration-200">
                    <td className="px-6 py-4">
                      <div className="flex items-center">
                        <i className="ri-briefcase-line text-2xl text-teal-600 mr-3"></i>
                        <span className="text-gray-800 font-medium">Business Development</span>
                      </div>
                    </td>
                    <td className="px-6 py-4">
                      <div className="flex items-center">
                        <i className="ri-flashlight-line text-2xl text-teal-600 mr-3"></i>
                        <span className="text-gray-800">Fast 24-48hr Quote Support</span>
                      </div>
                    </td>
                    <td className="px-6 py-4">
                      <div className="flex items-center">
                        <i className="ri-trophy-line text-2xl text-teal-600 mr-3"></i>
                        <span className="text-gray-800 font-semibold">Close More Deals</span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* CTA */}
          <div className="text-center">
            <a
              href="#contact"
              className="inline-flex items-center px-8 py-4 bg-teal-600 text-white font-semibold rounded-lg hover:bg-teal-700 transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
            >
              <i className="ri-rocket-line mr-2 text-xl"></i>
              Expand My Scope
            </a>
            <p className="mt-4 text-gray-600">
              Ready to take on bigger projects? Let's talk about scaling your business.
            </p>
          </div>
        </div>
      </section>
    </>
  );
}
